import { Col, Form, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../utilz/i18n';
import Button from '../../../components/Buttons/Button';
import FilterCard from '../../../components/Cards/FilterCard';
import { StateSelect } from '../components';
import TMSFiledCard from '../components/TMSFiledCard';

const CarrierSearchCard = ({ data, handleSelect, labelForTestId }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <FilterCard
      className="mb-15"
      showBorder
      shadow
      customHeader={
        <div className="w-100">
          <Row align="middle" justify="space-between">
            <Col>
              <TMSFiledCard
                title={t('translation:default.fields.transportationProvider.label')}
                labelForTestId={`${labelForTestId}-card-transportationProvider`}
              >
                {data?.carrierName}
              </TMSFiledCard>
            </Col>
            <Col>
              <Button onClick={() => handleSelect(data)} data-testid={`${labelForTestId}-card-select`}>
                {t('translation:default.buttons.select')}{' '}
              </Button>
            </Col>
          </Row>
        </div>
      }
      labelForTestId={`${labelForTestId}-card-provider-${data?.carrierScacCode}`}
    >
      <div className="px-15 pt-10 py-15">
        <Row gutter={15} align="middle">
          <Col flex={1}>
            <Row gutter={15} align="middle">
              <Col sm={4}>
                <TMSFiledCard
                  title={t('translation:default.fields.scac.label')}
                  labelForTestId={`${labelForTestId}-card-scac`}
                >
                  {data?.carrierScacCode}
                </TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard
                  title={t('translation:default.fields.address.label')}
                  labelForTestId={`${labelForTestId}-card-address`}
                >
                  {data?.carrierAddr1}
                </TMSFiledCard>
              </Col>
              <Col sm={4}>
                <TMSFiledCard
                  title={t('translation:default.fields.country.label')}
                  labelForTestId={`${labelForTestId}-card-country`}
                >
                  {data?.countryName}
                </TMSFiledCard>
              </Col>
              <Col sm={4}>
                <TMSFiledCard
                  title={t('translation:default.fields.postalCode.label')}
                  labelForTestId={`${labelForTestId}-card-postalCode`}
                >
                  {data?.carrierZip}
                </TMSFiledCard>
              </Col>
              <Col sm={3}>
                <Form
                  initialValues={{
                    state: String(data?.carrierState ? data?.carrierState : '').trim(),
                  }}
                >
                  <StateSelect name="state" editMode={false} margin="m-0" countryCode={data?.carrierCountry} />
                </Form>
              </Col>
              <Col sm={3}>
                <TMSFiledCard
                  title={t('translation:default.fields.city.label')}
                  labelForTestId={`${labelForTestId}-card-city`}
                >
                  {data?.carrierCity}
                </TMSFiledCard>
              </Col>
            </Row>
          </Col>
          <Col />
        </Row>
      </div>
    </FilterCard>
  );
};

export default CarrierSearchCard;
